import useApi from "@/hooks/useApi";
import * as React from "react";

export function useTags() {
  const [tags, setTags] = React.useState<string[]>([]);
  const api = useApi();

  React.useEffect(() => {
    async function fetchTags() {
      try {
        const response = await api.admin.get("api/kb/tags");
        const json = await response.json();
        setTags(Array.isArray(json) ? json : []);
      } catch (err) {
        console.error("Failed to fetch KB tags:", err);
        setTags([]);
      }
    }

    fetchTags();
  }, []);

  return { tags };
}
